import React, { useEffect, useMemo, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { useParams } from "react-router-dom";
import { db } from "../services/firebase";

function renderBlock(block, idx) {
  const title = block.headline || block.title || block.subhead || block.type || "Block";
  return (
    <div key={idx} className="panel" style={{ border: "1px dashed #cbd5e1" }}>
      <div className="section-header" style={{ marginBottom: "6px" }}>
        <div className="section-header__title">{title}</div>
      </div>
      {block.copy && <p>{block.copy}</p>}
      {block.fields && (
        <div className="grid" style={{ gap: "8px" }}>
          {block.fields.map((field) => (
            <input key={field} placeholder={field} />
          ))}
        </div>
      )}
      {block.cta && <button className="button" style={{ marginTop: "8px" }}>{block.cta}</button>}
    </div>
  );
}

function AppPreviewPage() {
  const { appId } = useParams();
  const [data, setData] = useState(null);
  const [status, setStatus] = useState("loading");

  const canvas = useMemo(() => {
    if (!data) return null;
    try {
      return JSON.parse(data.canvas || "{}") || {};
    } catch (err) {
      return null;
    }
  }, [data]);

  useEffect(() => {
    const fetchApp = async () => {
      const ref = doc(db, "webApps", appId);
      const snapshot = await getDoc(ref);
      if (!snapshot.exists()) {
        setStatus("not-found");
        return;
      }
      setData({ id: snapshot.id, ...snapshot.data() });
      setStatus("ready");
    };

    fetchApp();
  }, [appId]);

  if (status === "loading") {
    return <div className="splash">Loading app experience...</div>;
  }

  if (status === "not-found") {
    return <div className="splash">This app is not available.</div>;
  }

  return (
    <div className="main-content" style={{ padding: "32px" }}>
      <div className="section-header" style={{ marginBottom: "12px" }}>
        <h1 className="section-header__title">{data?.name || "Untitled App"}</h1>
        <p className="muted">{data?.description || "Draft preview"}</p>
      </div>

      <div className="grid" style={{ gap: "12px" }}>
        {canvas?.blocks?.map((block, idx) => renderBlock(block, idx))}
        {!canvas?.blocks && <p className="muted">Canvas JSON is missing blocks. Nothing to render.</p>}
      </div>
    </div>
  );
}

export default AppPreviewPage;
